// extracted by mini-css-extract-plugin
export var active = "_iq-2";
export var recordingDot = "_iq-1";
export var recordingIndicator = "_iq-0";